// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1RLaN","notes":"Notes_notes__1X24O"};